import Vue from 'vue'
import http from '@/services/http.service'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.dialog) this.$account = options.account
    else if (options.parent && options.parent.$account)
      this.$account = options.parent.$account
  },
})

/**
 * アカウントのソート
 *
 * 組織 -> 権限 -> ログインIDの順でソートします。
 */
function sortAccounts(accounts) {
  return accounts.sort((a, b) => {
    if (a.organization < b.organization) {
      return -1
    } else if (a.organization > b.organization) {
      return 1
    }

    const aIsAdmin = a.roles.includes('admin')
    const bIsAdmin = b.roles.includes('admin')
    if (aIsAdmin < bIsAdmin) {
      return 1
    } else if (aIsAdmin > bIsAdmin) {
      return -1
    }

    if (a.loginId < b.loginId) {
      return -1
    } else if (a.loginId > b.loginId) {
      return 1
    }
  })
}

export default {
  /**
   * アカウント一覧の取得
   */
  async getAccounts(companyCode) {
    const response = await http.get(`/accounts/${companyCode}`)
    return sortAccounts(response.data)
  },
  /**
   * アカウント取得
   */
  async getAccount(companyCode, loginId) {
    try {
      const response = await http.get(`/accounts/${companyCode}/${loginId}`)
      return response.data
    } catch (error) {
      if (error.response.status === 404) {
        return undefined
      } else {
        throw error
      }
    }
  },
  /**
   * アカウント登録
   */
  async addAccount(companyCode, accountProps) {
    try {
      await http.post(`/accounts/${companyCode}`, accountProps)
    } catch (e) {
      // アクシデントではないエラーとして、ID重複はあり得る。
      if (
        e.response.status === 400 &&
        e.response.data.cause === 'DuplicatedLoginId'
      ) {
        return e.response.data
      }

      throw new Error(e)
    }
  },
  /**
   * アカウント編集
   */
  async updateAccount(companyCode, loginId, accountProps) {
    await http.post(`/accounts/${companyCode}/${loginId}`, accountProps)
  },
  /**
   * アカウント削除
   */
  async deleteAccount(companyCode, loginId) {
    await http.delete(`/accounts/${companyCode}/${loginId}`)
  },
  /**
   * ログインパスワード変更
   */
  async changePassword(companyCode, loginId, newPassword) {
    await http.post(`/accounts/${companyCode}/${loginId}/password/update`, {
      newPassword: newPassword,
    })
  },
  /**
   * ログインパスワードリセット
   */
  async resetPassword(companyCode, loginId) {
    await http.post(`/accounts/${companyCode}/${loginId}/password/reset`)
  },
  /**
   * POS閲覧可能分類取得
   */
  async getUserPosCategories(userId) {
    const response = await http.get(`/accounts/dummy/${userId}/pos_categories`)
    return response.data
  },
  /**
   * POS閲覧可能分類一覧取得
   */
  async getUsersCategory(companyCode) {
    const response = await http.get(`/accounts/${companyCode}/categories`)
    return response.data
  },
  /**
   * アップロード
   * @param {*} companyCode
   * @param {*} file
   * @returns
   */
  async upload(companyCode, file) {
    try {
      const formData = new FormData()
      formData.append('file', file)

      const response = await http.post(
        `/accounts/${companyCode}/upload/file`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      )

      return response.data
    } catch (error) {
      if (error.response.status === 400) {
        return null
      }
      throw error
    }
  },
}
